import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';

var ExpandArrow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ExpandArrow, _React$PureComponent);

  var _super = _createSuper(ExpandArrow);

  function ExpandArrow() {
    var _this;

    _classCallCheck(this, ExpandArrow);

    _this = _super.apply(this, arguments);

    _this.handleClick = function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          expanded = _this$props.expanded,
          rowKey = _this$props.rowKey;
      onChange(rowKey, !expanded);
    };

    return _this;
  }

  _createClass(ExpandArrow, [{
    key: "render",
    value: function render() {
      var expanded = this.props.expanded;
      return /*#__PURE__*/React.createElement("span", {
        className: "roo-table-arrow cursor-pointer",
        onClick: this.handleClick
      }, /*#__PURE__*/React.createElement("i", {
        className: "roo-icon roo-icon-chevron-".concat(expanded ? 'down' : 'right')
      }));
    }
  }]);

  return ExpandArrow;
}(React.PureComponent);

export { ExpandArrow as default };